module.exports = __webpack_public_path__ + "img/tree-04-a-leaves.0b5b2825.png";